export const CAPACITY_MODE = {
  POWER_OUTPUT: 'powerOutput',
  RATED_CAPACITY: 'ratedCapacity',
};

// value of a powerplant's `sizing_basis` parameter when its size is pinned rather
// than derived from output. In that mode the capacity factor is a result, not an
// input, so there is nothing to convert a rated capacity into an average output with.
export const SIZED_BY_NAMEPLATE = 'Nameplate Capacity';
